import { css } from '@src/common/styles/Styles';

export const menuItemStyle = css((theme) => ({
  ':hover': {
    backgroundColor: theme.palette.secondary.secondaryContainer,
  },
}));

export const actionIconStyle = { height: '20px', marginRight: '6px' };
